module.exports = __webpack_public_path__ + "img/background-helicopter.c9b28163.png";